const shim = () => null
shim.isRequired = shim
const factory = () => shim

const PropTypes = {}
;['array','bool','func','number','object','string','symbol','any','element','elementType','node']
  .forEach(t => { PropTypes[t] = shim })
;['arrayOf','instanceOf','objectOf','oneOf','oneOfType','shape','exact']
  .forEach(t => { PropTypes[t] = factory })
PropTypes.checkPropTypes = () => {}
PropTypes.resetWarningCache = () => {}
PropTypes.PropTypes = PropTypes
module.exports = PropTypes
